
import React from 'react'
import { Link } from 'gatsby'

import style from './Sidebar.module.scss'

// Map verbs to shorter names
const VERBS = {
  'get': 'GET',
  'options': 'OPTS',
  'post': 'POST',
  'put': 'PUT',
  'patch': 'PATCH',
  'delete': 'DEL',
}

const SidebarEndpoint = ({ 
  endpoint, 
  location
}) => (
  <Link
    className={style.link}
    activeClassName={style.activeAnchor}
    to={endpoint.urlPath}
    data-selected={endpoint.urlPath === location.pathname}
  >
    <span 
      className={style.verb} 
      data-verb={endpoint.verb}
      aria-hidden>{ VERBS[endpoint.verb] }
    </span>
    <p>{ endpoint.title }</p>
  </Link>
)

export default SidebarEndpoint